import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader.js';
import {DRACOLoader} from 'three/examples/jsm/loaders/DRACOLoader.js';
import bidello,{component} from "bidello";

export class MeshLoader extends component(GLTFLoader){

    init() {
        this.objectSources = [];

    }

    setObjectSource (meshSrc){

        bidello.trigger({ name: 'meshAdded' }, { name: meshSrc});

    }

    loadObject(meshSrc,trigger = true,callback = ()=>{}) {

        const loader = new GLTFLoader();
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath("/decoders/draco/");
        this.setDRACOLoader(dracoLoader);
        let mesh = (!meshSrc) ? this.defaultMesh : meshSrc
        const promise = new Promise((resolve, reject) => {

            this.load(mesh,
                (gltf) => {
                    //resolve(gltf.scene);
                    //this.updateLoader(1, false);
                    if (trigger)bidello.trigger({ name: 'meshLoaded' }, { resources: gltf.scene,name:meshSrc});
                    callback(gltf.scene);

                },
                (xhf) => {

                    //bidello.trigger({ name: 'meshProgress' }, { name:meshSrc});


                },
                (err) => {

                    reject(err);

                }
            )
        });

        return promise;
    }

}

export const meshLoader = new MeshLoader();